module.exports = __webpack_public_path__ + "12774882bfd9013393f7d7554cde359c.png";